import { ConditionalWrapper } from "@sundae/ui-toolkit";
import { motion } from "framer-motion";
import { FC, HTMLAttributes, PropsWithChildren } from "react";
import { DEFAULT_MOTION_PROPS, fadeInMotion } from "../../constants/motions.constants";
import { useProfileAppContext } from "../../stores";

export const PageContent: FC<PropsWithChildren<HTMLAttributes<HTMLDivElement>>> = ({
  children,
  className,
}) => {
  const {
    state: { prefersReducedMotion },
  } = useProfileAppContext();

  return (
    <ConditionalWrapper
      condition={!prefersReducedMotion}
      wrapper={(children) => (
        <motion.section {...DEFAULT_MOTION_PROPS} variants={fadeInMotion}>
          {children}
        </motion.section>
      )}
    >
      <div className={className}>{children}</div>
    </ConditionalWrapper>
  );
};

export default PageContent;
